import { convertToIsoString } from '@/utils/commons'
import { useState, useRef, useCallback } from 'react'

const getType = (obj) => {
  const { type, field } = obj || {};
  if (!type) return type;
  if (field === 'rewardId') {
    return 'integer';
  }
  return typeof type === 'string' && type?.toLowerCase() === 'text' ? 'string' : type;
}

export const useDataTable = ( firstPageIndex, isNotUtcDate, clearSearchArray,initialSortConfig={} ) => {
  const [sortingObj, setSortingObj] = useState(initialSortConfig)
  const [searchArr, createSearchArray] = useState([])
  const [pageIndex, setPageIndex] = useState(firstPageIndex || 0)
  const clearArrayRef = useRef(false);

  const handleDateType = (searchObj) => {
    if (!searchObj.value) {
      searchObj.value = '';
      return;
    }
    const dateString = searchObj.value;
    const utcDate = new Date(dateString.split('T')[0]);
    const date = new Date(Date.UTC(utcDate.getFullYear(), utcDate.getMonth(), utcDate.getDate()));
    if (isNaN(date.getTime())) {
      searchObj.value = '';
    } else if (isNotUtcDate){
      searchObj.value = dateString.split('T')[0];
    } else {
      // Only isStartDate should be true for a single date, isEndDate should be false
      searchObj.value = convertToIsoString(date, true, false);
    }
  };

  const setSearchArry = (() => {
    let debounceTimer

    return searchObj => {
      // Convert type if it's a text field
      if (searchObj.type) {
        searchObj.type = getType(searchObj)
      }

      if (searchObj.type === 'date') {
        handleDateType(searchObj)
      }

      if (searchObj.type === 'dateRange') {
        const { from, to } = searchObj.value

        const formatDate = (dateString, isStartDate, isEndDate) => {
          if (!dateString) return ''
          const utcDate = new Date( dateString.split('T')[0])

          const date = new Date(Date.UTC(utcDate.getFullYear(), utcDate.getMonth(), utcDate.getDate()))
          if (isNaN(date.getTime())) return '' // Invalid date
          return convertToIsoString(date, isStartDate, isEndDate)
        }

        const formattedFromDate = formatDate(from, true, false)
        const formattedToDate = formatDate(to, false, true)

        // Set value to empty if both dates are empty or invalid
        if (!formattedFromDate && !formattedToDate) {
          searchObj.value = ''
        } else {
          searchObj.value = `${formattedFromDate},${formattedToDate}`
        }
      }

      clearTimeout(debounceTimer)
      debounceTimer = setTimeout(() => {
        const isEmptyValue = (value) => {
          if (!value || value === '') return true
          if (searchObj.type === 'dateRange' && (value === ',' || value === ',,' || value.split(',').every(d => !d))) return true
          return false
        }

        // Remove items with empty values and handle new search
        if (clearArrayRef.current && isEmptyValue(searchObj.value)){
          createSearchArray([])
          clearArrayRef.current = false;
        } else if (isEmptyValue(searchObj.value)) {
          // Remove the item with the matching field
          const filteredArray = searchArr.filter(filter => filter.field !== searchObj.field)
          createSearchArray(filteredArray)
        } else {
          // Update existing or add new item
          const index = searchArr.findIndex(filter => filter.field === searchObj.field)
          if (index !== -1) {
            // Update existing item
            const updatedArray = [...searchArr]
            updatedArray[index] = searchObj
            createSearchArray(updatedArray)
          } else {
            // Add new item
            createSearchArray([...searchArr, searchObj])
          }
        }
      }, 1000)
    }
  })()

  const resetSearchArr = () => {
    createSearchArray([])
  }


  const handleResetAll = useCallback(() => {
    if (clearSearchArray){
      clearArrayRef.current = true;
    }
    createSearchArray([])
    setSortingObj(initialSortConfig || {})
    setPageIndex(firstPageIndex || 0)
  }, [clearSearchArray, createSearchArray, setSortingObj, setPageIndex, firstPageIndex, initialSortConfig])

  return {
    searchArr,
    sortingObj,
    pageIndex,
    setSortingObj,
    setSearchArry,
    setPageIndex,
    resetSearchArr,
    handleResetAll
  }
}

